import {
  Button,
  Container,
  Fab,
  makeStyles,
  Modal,
  Snackbar,
  Tooltip,
} from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import React, { useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import UploadAndDownloadService from "../services/uploadAndDownloadFile";
import PurchaseService from "../services/PurchaseOrder";
import $ from "jquery";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 500,
    height: 200,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
    },
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  cancelAndAddButtom: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const UploadFactureFileInPageDetailFactureAchat = ({
  setOnUploadFile,
  factureUploadInformation,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [factureImageFile, setFactureImageFile] = useState([]);

  $(".custom-file-input").on("change", function () {
    var fileNameTwo = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileNameTwo);
  });

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenInfoAlert(false);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnUploadFile(false);
  };

  const onUploadLocalFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setFactureImageFile(e.target.files[0]);
    }
  };

  const onUploadFileToBackendHandler = () => {
    if (factureImageFile.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucun fichier");
      return;
    }

    const uploadData = new FormData();
    uploadData.append("picture", factureImageFile);

    UploadAndDownloadService.uploadFile(
      "/retail/uploadFile/uploadFile/Facture",
      uploadData
    )
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          PurchaseService.updateFacturePathFile(
            factureUploadInformation.reference,
            response.data.success
          )
            .then((res) => {
              if (Object.keys(res.data)[0] === "success") {
                setOnUploadFile(false);
                window.location.reload(false);
              } else {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : mise à jour échouée");
              }
            })
            .catch(() => {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : problème de connexion");
            });
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : upload échoué");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : problème de connexion");
      });
  };

  return (
    <>
      <Tooltip title="Add" aria-label="add" onClick={() => setOpen(true)}>
        <Fab color="primary" className={classes.fab}>
          <AddIcon />
        </Fab>
      </Tooltip>
      <Modal open={open}>
        <Container className={classes.container}>
          <form className={classes.form} autoComplete="off">
            <div className={classes.item}>
              <label htmlFor="factureFileInput">Document facture</label>
              <div className="input-group">
                <div className="custom-file">
                  <input
                    accept="application/pdf, .jpg, .jpeg, .png"
                    type="file"
                    className="custom-file-input"
                    id="factureFileInput"
                    onChange={onUploadLocalFileHandler}
                  />
                  <label className="custom-file-label" htmlFor="factureFileInput">
                    Choisir un fichier
                  </label>
                </div>
              </div>
            </div>
            <div className={classes.cancelAndAddButtom}>
              <Button
                variant="outlined"
                color="primary"
                style={{ marginRight: 20 }}
                onClick={onUploadFileToBackendHandler}
              >
                Ajouter
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={onCancelButtonHandler}
              >
                Quitter
              </Button>
            </div>
          </form>
        </Container>
      </Modal>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UploadFactureFileInPageDetailFactureAchat;
